import { motion } from 'framer-motion';
import V10_1 from '../../assets/images/home/vector10/vector10-1.svg';
import V10_2 from '../../assets/images/home/vector10/vector10-2.svg';
import V10_3 from '../../assets/images/home/vector10/vector10-3.svg';
import V10_4 from '../../assets/images/home/vector10/vector10-4.svg';
import V10_5 from '../../assets/images/home/vector10/vector10-5.svg';
import V10_6 from '../../assets/images/home/vector10/vector10-6.svg';
import V10_7 from '../../assets/images/home/vector10/vector10-7.svg';

const Vector10 = () => {
  return (
    <motion.div className="vector" id="vector10"
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true, amount: 0.9 }}
    >
      <img src={V10_1} alt="Décoration au milieu" />
      <img src={V10_2} alt="Décoration au milieu" />
      <img src={V10_3} alt="Décoration au milieu" />
      <img src={V10_4} alt="Décoration au milieu" />
      <img src={V10_5} alt="Décoration au milieu" />
      <img src={V10_6} alt="Décoration au milieu" />
      <img src={V10_7} alt="Décoration au milieu" />
    </motion.div>
  );
};

export default Vector10;